import { render, staticRenderFns } from "./Sonarr.vue?vue&type=template&id=13a9129c&scoped=true&"
import script from "./Sonarr.vue?vue&type=script&lang=js&"
export * from "./Sonarr.vue?vue&type=script&lang=js&"
import style0 from "./Sonarr.vue?vue&type=style&index=0&id=13a9129c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a9129c",
  null
  
)

export default component.exports